import React from 'react'
import { Link } from 'react-router-dom'
import Grid from '@material-ui/core/Grid'
import OpalHeading from '../../../opal/OpalHeading'
import OpalCard from '../../../opal/OpalCard'
import FadeIn from '../../../molecules/Transitions/FadeIn'
import FlexRow from '../../../molecules/FlexRow'
import UserThreadList from './UserThreadList'

function AbundanceDesignerIndex () {
  return (
    <FadeIn className='pt-5' style={{ maxWidth: '900px', margin: '0 auto' }}>
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <OpalCard size='md' className='w-full relative flex flex-col'>
            <section className='flex-1'>
              <OpalHeading className='font-size-xl'>Abundance Designer</OpalHeading>
              <p className='font-weight-thin'>Chat with an AI agent to design new Abundance Engine Views</p>
            </section>
            <FlexRow className='justify-end gap-md'>
              <Link className='btn-primary-md' to='/denali-labs/abundance-designer/playground'>
                New Chat
              </Link>
            </FlexRow>
          </OpalCard>
        </Grid>
        <Grid item xs={12}>
          <UserThreadList />
        </Grid>
      </Grid>
    </FadeIn>
  )
}

export default AbundanceDesignerIndex
